/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* sihwtijdveld.module.ts
* 13-3-2020 - Jelmer Jellema - Spin in het Web B.V.
*
* Eenvoudige tijdinput met validatie en rewrite
* <sihwtijdveld [(ngModel)=....] voorloopnul=<boolean>>
* voorloopnul is standaard false(!). Als deze true is dan worden uren altijd met 2 decimalen afgebeeld
* Overgenomen attributen: placeholder, size
*/
import {NgModule} from '@angular/core';
import {SihwlogModule} from '../../sihwlog/sihwlog.module';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SihwTijdveld} from './sihwtijdveld';

@NgModule({
  declarations: [
    SihwTijdveld
  ],
  imports: [
    SihwlogModule,
    CommonModule,
    FormsModule
  ],
  exports: [SihwTijdveld]
}) export class SihwtijdveldModule {}
